<template>
  <v-container>
    <div>
      <v-file-input
        :label="$t('views.downloadcenter.icon')"
        v-on:change="uploadImg"
        ref="fileIcon"
        accept=".jpg, .png"
      ></v-file-input>
    </div>
    <div style="height: 1200px">
      <vueCropper
        ref="cropper"
        :img="imageData"
        :canMove="false"
        :canMoveBox="false"
        :info="true"
        :autoCrop="true"
        outputType="png"
        @realTime="realTime"
      ></vueCropper>
    </div>
    <div
      v-if="previews"
      class="show-preview"
      :style="{
        width: previews.w + 'px',
        height: previews.h + 'px',
        overflow: 'hidden',
        margin: '5px',
      }"
    >
      <div :style="previews.div">
        <img :src="previews.url" :style="previews.img" />
      </div>
    </div>

    <div class="col-auto align-self-center">
      <div ref="icon" style="width: 50px;" class="svg-icon"></div>
    </div>

    <div class="col-auto align-self-center">
      <v-btn :loading="saving" color="primary" @click="saveImageHandler" :disabled="!imageData">{{
        $t("globals.save")
      }}</v-btn>
    </div>
  </v-container>
</template>
<script>
import { VueCropper } from "vue-cropper";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    VueCropper,
  },
  data: () => ({
    saving: false,
    uploadUrl: undefined,
    imageData: undefined,
    previews: undefined,
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  props: {
    image: Object,
  },

  methods: {
    ...mapActions("downloadCenter", ["uploadFile", "saveImage"]),
    async saveImageHandler() {
      this.saving = true;
      const data = await new Promise((resolve, reject) => {
        this.$refs.cropper.getCropData((data) => {
          resolve(data);
        });
      });
      const res = await this.uploadFile({ base64: data, name: "cropped.png" });
      let img = { PhysicalFileId: res.Id, PlanId: this.selectedPlan.Id };
      const image = await this.saveImage(img);
      img.Id = image;
      this.$emit("update:image", img);
      this.saving = false;
    },
    async uploadImg($event) {
      //console.log($event);

      const reader = new FileReader();
      const file = $event;
      reader.readAsDataURL(file);
      const contents = await new Promise((resolve, reject) => {
        reader.onload = function(event) {
          resolve(reader.result);
        };
      });
      this.imageData = contents; //.split(',')[1];
    },
    realTime(data) {
      this.previews = data;
    },
  },
};
</script>
<style>
.vue-cropper {
  background-repeat: repeat;
}
</style>
